import {
    Box, Typography, Tooltip, Table, TableBody, TableCell, TableHead, TableRow,
} from '@mui/material';
import { Warning } from '@mui/icons-material';
import { CopyButton } from 'src/components/common/CopyButton';

interface DestinationProductOptionsProps {
    destinationOptions: Record<string, string>;
    inputOptions: Record<string, string>;
}

export const DestinationProductOptions = ({
    destinationOptions,
    inputOptions,
}: DestinationProductOptionsProps): JSX.Element => {
    const isDifferent = (key: string, value: string):
    boolean => inputOptions[key] !== undefined && inputOptions[key] !== value;

    return (
        <Box>
            <Box sx={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1,
            }}
            >
                <Typography gutterBottom variant="h6">
                    Destination Product Options
                </Typography>
                <CopyButton
                    size="large"
                    textToCopy={JSON.stringify(destinationOptions, null, 2)}
                    tooltipTitle="Click to copy the JSON string to your clipboard"
                />
            </Box>
            <Box
                sx={{
                    backgroundColor: 'grey.100',
                    borderRadius: 1,
                    overflowY: 'auto',
                }}
            >
                <Table size="small" sx={{ backgroundColor: 'background.paper' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>Name</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>Value</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.entries(destinationOptions).length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={2} sx={{ textAlign: 'center', py: 4 }}>
                                    <Typography color="text.secondary" variant="body2">
                                        No destination product options detected
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            Object.entries(destinationOptions).map(([key, value]) => (
                                <TableRow key={key}>
                                    <TableCell><Typography variant="body1">{key}</Typography></TableCell>
                                    <TableCell sx={{ fontSize: '1rem' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography variant="body1">{value}</Typography>
                                            {isDifferent(key, value) && (
                                                <Tooltip title="This value differs from the input product options">
                                                    <Warning color="warning" fontSize="small" />
                                                </Tooltip>
                                            )}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </Box>
        </Box>
    );
};
